var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPerusahaanMitra({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3920_1070)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6595 14.0968C5.73141 18.7567 3.19951 26.2449 6.38638 32.9468C9.13678 38.7309 14.354 32.108 20.9533 31.9098C28.6966 31.6774 39.0523 39.1529 40.9281 31.9098C42.8071 24.654 30.5803 17.9871 23.9531 14.0956C17.6191 10.3762 17.4071 9.5788 11.6595 14.0968Z",
    fill: "#EDF9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37256 23.5741L1.99902 20.2006L11.5063 11L14.8798 14.6802M5.37256 23.5741L14.8798 14.6802M5.37256 23.5741C5.37256 23.5741 10.8348 33.4708 17.0266 35.2281C23.454 37.0523 28.8561 35.6518 33.5876 30.9345M14.8798 14.6802C14.8798 14.6802 19.508 14.6802 22.8536 13.7602M30.8274 14.6802L34.5076 11L44.0149 20.2006L40.6413 23.5741M30.8274 14.6802L40.6413 23.5741M30.8274 14.6802C30.8274 14.6802 25.249 13.1014 22.8536 13.7602M40.6413 23.5741C40.6413 23.5741 36.3423 28.0601 33.5876 30.9345M22.8536 13.7602C21.0135 15.2936 16.4132 19.8939 16.4132 19.8939C13.0397 22.654 16.1065 27.2543 19.7868 24.4941L21.9336 22.654L23.7737 21.1206C26.8405 24.4941 29.294 30.9345 33.5876 30.9345",
    stroke: "#A2CD3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.827 14.6802L34.5072 11L44.0145 20.2006L40.6409 23.5741M30.827 14.6802L40.6409 23.5741M30.827 14.6802C30.827 14.6802 25.2485 13.1014 22.8532 13.7602C21.0131 15.2936 16.4128 19.8939 16.4128 19.8939C13.0393 22.654 16.1061 27.2543 19.7863 24.4941L21.9331 22.654L23.7732 21.1206C26.8401 24.4941 29.2936 30.9345 33.5872 30.9345C36.3418 28.0601 40.6409 23.5741 40.6409 23.5741",
    stroke: "#29ABE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3920_1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(-0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerusahaanMitra);
export default __webpack_public_path__ + "static/media/ic-perusahaan-mitra.0ec920e45e8aaeae744d293ceba5690f.svg";
export { ForwardRef as ReactComponent };